import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Location } from '~/types';
import { cleanupFormValues } from '~/utils';
import LocationForm from './LocationForm';
import { locations } from '~/routes';
import { FormDrawer } from '~/components';
import { useLocationsCreate } from '~/hooks/locations';

const LocationCreate: FC<any> = () => {
  const [t] = useTranslation('locations');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = useLocationsCreate(handleClose);

  const onFinish = (values: Location) => {
    mutate(cleanupFormValues(values));
  };

  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {t('addLocation')}
      </Button>
      <FormDrawer
        name={locations}
        onFinish={onFinish}
        title={t('addLocation')}
        onClose={handleClose}
        visible={open}
      >
        <LocationForm name={locations} />
      </FormDrawer>
    </>
  );
};

export default LocationCreate;
